// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.BulkActionsBar_bulkActionsBar__IHMBW {
  background-color: #FFFFFF;
  border: 1px solid #dee2e6;
  border-radius: 4px;
  padding: 0.75rem 1rem;
  margin-bottom: 1rem;
}
.BulkActionsBar_bulkActionsBar__IHMBW .BulkActionsBar_content__nNdwm {
  display: flex;
  align-items: center;
  gap: 1rem;
}
.BulkActionsBar_bulkActionsBar__IHMBW .BulkActionsBar_label__Smv5G {
  font-weight: 600;
  color: #495057;
}
.BulkActionsBar_bulkActionsBar__IHMBW .BulkActionsBar_selectedCount__qUtpv {
  color: #007bff;
  font-weight: 500;
  margin-left: auto;
}
.BulkActionsBar_bulkActionsBar__IHMBW .BulkActionsBar_selectedCount__qUtpv.BulkActionsBar_noSelection__ZJ0xq {
  color: #6c757d;
  font-style: italic;
}
.BulkActionsBar_bulkActionsBar__IHMBW .BulkActionsBar_clearButton__Vcp4n {
  padding: 0.25rem 0.5rem;
  color: black !important;
  text-decoration: none !important;
}
.BulkActionsBar_bulkActionsBar__IHMBW .BulkActionsBar_clearButton__Vcp4n:disabled {
  cursor: not-allowed;
  opacity: 0.5;
}

.BulkActionsBar_dropdownMenu__uWNRU {
  inset: auto !important;
  transform: none !important;
}`, "",{"version":3,"sources":["webpack://./src/components/pages/CertificateDetails/BulkActionsBar.module.scss"],"names":[],"mappings":"AAAA;EACE,yBAAA;EACA,yBAAA;EACA,kBAAA;EACA,qBAAA;EACA,mBAAA;AACF;AACE;EACE,aAAA;EACA,mBAAA;EACA,SAAA;AACJ;AAEE;EACE,gBAAA;EACA,cAAA;AAAJ;AAGE;EACE,cAAA;EACA,gBAAA;EACA,iBAAA;AADJ;AAGI;EACE,cAAA;EACA,kBAAA;AADN;AAKE;EACE,uBAAA;EACA,uBAAA;EACA,gCAAA;AAHJ;AAKI;EACE,mBAAA;EACA,YAAA;AAHN;;AAQA;EACI,sBAAA;EACA,0BAAA;AALJ","sourcesContent":[".bulkActionsBar {\r\n  background-color: #FFFFFF;\r\n  border: 1px solid #dee2e6;\r\n  border-radius: 4px;\r\n  padding: 0.75rem 1rem;\r\n  margin-bottom: 1rem;\r\n\r\n  .content {\r\n    display: flex;\r\n    align-items: center;\r\n    gap: 1rem;\r\n  }\r\n\r\n  .label {\r\n    font-weight: 600;\r\n    color: #495057;\r\n  }\r\n\r\n  .selectedCount {\r\n    color: #007bff;\r\n    font-weight: 500;\r\n    margin-left: auto;\r\n    \r\n    &.noSelection {\r\n      color: #6c757d;\r\n      font-style: italic;\r\n    }\r\n  }\r\n\r\n  .clearButton {\r\n    padding: 0.25rem 0.5rem;\r\n    color: black !important;\r\n    text-decoration: none !important;\r\n    \r\n    &:disabled {\r\n      cursor: not-allowed;\r\n      opacity: 0.5;\r\n    }\r\n  }\r\n}\r\n\r\n.dropdownMenu {\r\n    inset: auto !important;\r\n    transform: none !important;\r\n \r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"bulkActionsBar": `BulkActionsBar_bulkActionsBar__IHMBW`,
	"content": `BulkActionsBar_content__nNdwm`,
	"label": `BulkActionsBar_label__Smv5G`,
	"selectedCount": `BulkActionsBar_selectedCount__qUtpv`,
	"noSelection": `BulkActionsBar_noSelection__ZJ0xq`,
	"clearButton": `BulkActionsBar_clearButton__Vcp4n`,
	"dropdownMenu": `BulkActionsBar_dropdownMenu__uWNRU`
};
export default ___CSS_LOADER_EXPORT___;
